export default {"src":"/_next/static/media/Video2025AGIF.19b71279.gif","height":720,"width":960,"blurWidth":0,"blurHeight":0};